/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant;
 * });
 */

/* HT Darts: premium collection/category header */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-collection')) return;

  var cardHeader = document.querySelector('.collection__dynamic-part .card__header');
  var header = document.querySelector('.collection__dynamic-part .card__header .collection__header-inner');
  if (!cardHeader || !header) return;

  cardHeader.classList.add('htd-premium-category-header');
  header.classList.add('htd-premium-category-header__inner');

  if (!header.querySelector('.htd-category-kicker')) {
    var metaInner = header.querySelector('.collection__meta-inner');
    if (metaInner) {
      var kicker = document.createElement('div');
      kicker.className = 'htd-category-kicker';
      kicker.textContent = 'HIGH TENSION DARTS';
      metaInner.insertBefore(kicker, metaInner.firstChild);
    }
  }

  if (!header.querySelector('.htd-category-header-logo')) {
    var link = document.createElement('a');
    link.className = 'htd-category-header-logo';
    link.href = '/';
    link.setAttribute('aria-label', 'HT Darts home');

    var logo = document.createElement('img');
    logo.src = '/cdn/shop/files/7f91f714-e4f7-4c92-ba2e-8bd47b001131.png';
    logo.alt = 'HT Darts';
    logo.loading = 'eager';
    link.appendChild(logo);
    header.appendChild(link);
  }

  var style = document.createElement('style');
  style.textContent = `
    .template-collection .htd-premium-category-header{
      position:relative;
      overflow:hidden;
      min-height:150px;
      padding:0!important;
      border:1px solid rgba(255,255,255,.08)!important;
      border-bottom:4px solid #e31b2d!important;
      background:
        radial-gradient(circle at 82% 35%,rgba(227,27,45,.24),transparent 27%),
        linear-gradient(118deg,#050505 0%,#111 54%,#26070b 100%)!important;
      box-shadow:0 14px 32px rgba(0,0,0,.18)!important;
    }
    .template-collection .htd-premium-category-header:before{
      content:'';
      position:absolute;
      inset:0;
      pointer-events:none;
      background:linear-gradient(105deg,transparent 0 58%,rgba(255,255,255,.035) 58% 59%,transparent 59% 100%);
    }
    .template-collection .htd-premium-category-header:after{
      content:'';
      position:absolute;
      width:220px;
      height:220px;
      right:-80px;
      top:-120px;
      border:1px solid rgba(227,27,45,.26);
      border-radius:50%;
      pointer-events:none;
    }
    .template-collection .htd-premium-category-header .collection__header{
      min-height:150px;
      display:flex;
      align-items:center;
    }
    .template-collection .htd-premium-category-header__inner{
      position:relative;
      width:100%;
      min-height:150px;
      display:flex;
      flex-direction:column;
      justify-content:center;
      padding:28px 255px 28px 34px!important;
    }
    .template-collection .htd-premium-category-header .collection__meta,
    .template-collection .htd-premium-category-header .collection__meta-inner{
      position:relative;
      z-index:1;
    }
    .template-collection .htd-category-kicker{
      display:flex;
      align-items:center;
      gap:9px;
      margin:0 0 7px;
      color:#ff3345;
      font-size:11px;
      line-height:1;
      font-weight:900;
      letter-spacing:.2em;
    }
    .template-collection .htd-category-kicker:before{
      content:'';
      width:28px;
      height:3px;
      border-radius:3px;
      background:#e31b2d;
      box-shadow:0 0 12px rgba(227,27,45,.55);
    }
    .template-collection .htd-premium-category-header .collection__title{
      margin:0!important;
      color:#fff!important;
      font-size:36px!important;
      line-height:1.05!important;
      font-weight:900!important;
      letter-spacing:.015em!important;
      text-transform:uppercase;
      text-shadow:0 2px 14px rgba(0,0,0,.3);
    }
    .template-collection .htd-premium-category-header .collection__products-count{
      margin-top:9px!important;
      color:rgba(255,255,255,.62)!important;
      font-weight:700;
    }
    .template-collection .htd-premium-category-header .collection__description{
      position:relative;
      z-index:1;
      max-width:800px;
      margin-top:12px!important;
      color:rgba(255,255,255,.78)!important;
    }
    .template-collection .htd-premium-category-header .collection__description,
    .template-collection .htd-premium-category-header .collection__description p,
    .template-collection .htd-premium-category-header .collection__description a{
      color:rgba(255,255,255,.78)!important;
    }
    .template-collection .htd-category-header-logo{
      position:absolute;
      right:30px;
      top:50%;
      transform:translateY(-50%);
      z-index:3;
      display:flex;
      align-items:center;
      justify-content:center;
      width:190px;
      min-height:100px;
      padding:12px 14px;
      border:1px solid rgba(255,255,255,.11);
      border-radius:12px;
      background:linear-gradient(145deg,rgba(255,255,255,.08),rgba(255,255,255,.025));
      box-shadow:inset 0 1px rgba(255,255,255,.06),0 10px 24px rgba(0,0,0,.24);
      backdrop-filter:blur(2px);
    }
    .template-collection .htd-category-header-logo img{
      display:block;
      width:auto;
      max-width:160px;
      max-height:76px;
      object-fit:contain;
      filter:drop-shadow(0 5px 9px rgba(0,0,0,.35));
    }
    .template-collection .htd-category-header-logo:hover{
      border-color:rgba(227,27,45,.65);
      transform:translateY(-50%) scale(1.015);
    }
    @media(max-width:999px){
      .template-collection .htd-premium-category-header__inner{padding:24px 205px 24px 24px!important}
      .template-collection .htd-category-header-logo{right:22px;width:155px;min-height:88px}
      .template-collection .htd-category-header-logo img{max-width:132px;max-height:65px}
      .template-collection .htd-premium-category-header .collection__title{font-size:30px!important}
    }
    @media(max-width:640px){
      .template-collection .htd-premium-category-header,
      .template-collection .htd-premium-category-header .collection__header{min-height:124px}
      .template-collection .htd-premium-category-header__inner{
        min-height:124px;
        padding:20px 112px 20px 16px!important;
      }
      .template-collection .htd-category-kicker{font-size:8.5px;letter-spacing:.13em;margin-bottom:6px}
      .template-collection .htd-category-kicker:before{width:18px;height:2px}
      .template-collection .htd-premium-category-header .collection__title{font-size:23px!important;line-height:1.08!important}
      .template-collection .htd-premium-category-header .collection__description{font-size:12px;line-height:1.45;margin-top:8px!important}
      .template-collection .htd-category-header-logo{
        right:12px;
        width:88px;
        min-height:68px;
        padding:8px;
        border-radius:9px;
      }
      .template-collection .htd-category-header-logo img{max-width:74px;max-height:50px}
    }
  `;
  document.head.appendChild(style);
});
